export enum CountryEnum {
  Austria = 'Austria',
  Germany = 'Germany',
  Switzerland = 'Switzerland'
}
